import { useContext, useEffect, useState } from "react"
import AOS from 'aos';
import { AppContext } from "../App"
import { getInlineLoader } from "../Helpers";
import OneProject from "./OneProject";

export default function ProjectsBanner() {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ ready, setReady ] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllProjects(),
    ])
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }, []);

  if (ready) {

    const isHomePage = appContext.navItem === "" || appContext.navItem === "home";
    const isProjectsPage = appContext.navItem === "pprojects";
    const displayedProjects = isHomePage ? (appContext.allProjects || []).slice(0, 3) : (appContext.allProjects || []);

    return (
      <div 
        className="MainBodySection bg-background text-primary"
        style={{
          paddingTop: "80px",
          paddingBottom: "80px",
          background: "linear-gradient(180deg, rgba(248,250,252,1) 0%, rgba(255,255,255,1) 100%)"
        }}
      >
        <div className="container">
          <div className="row">

            <div className="col-md-12 mb-5 text-center" data-aos="fade-up">
              <span 
                className="section-subtitle font-semi-bold mb-3 text-primary fs-3 text-uppercase"
                style={{ 
                  letterSpacing: "2.5px", 
                  fontSize: "0.85rem",
                  color: "#3b82f6",
                  fontWeight: "700"
                }}
              >
                Our Work
              </span>
              <h2 
                className="section-title font-bold"
                style={{ 
                  maxWidth: "850px", 
                  margin: "0 auto 1rem", 
                  fontWeight: "800",
                  fontSize: "2.25rem",
                  lineHeight: "1.3",
                  color: "#0f172a"
                }}
              >
                Transforming Business Challenges into Strategic Opportunities
              </h2>
              <p 
                className="text-muted"
                style={{ 
                  maxWidth: "650px", 
                  margin: "0 auto", 
                  fontSize: "1.1rem",
                  lineHeight: "1.7",
                  color: "#475569"
                }}
              >
                Explore our portfolio of successful consulting engagements where we've helped organizations 
                optimize operations, drive growth, and achieve sustainable results.
              </p>
            </div>

            {
              displayedProjects.length > 0 ?
              displayedProjects.map((item, i) => (
                <div 
                  key={i} 
                  className="col-md-4"
                  data-aos="fade-up" 
                  data-aos-delay={i * 150}
                >
                  <OneProject data={item}/>
                </div>
              ))
              :
              <div className="col-md-12 mb-1 mt-1 text-muted text-center" data-aos="fade-up">
                <h6 style={{ fontWeight: "500" }}>No projects available at this time</h6>
                <p className="text-secondary small">Check back soon for new case studies and success stories.</p>
              </div>
            }

            {/* View More Button for Home */}
            {
              isHomePage && appContext.allProjects.length > 3 &&
              <div className="col-md-12 mt-5 text-center" data-aos="fade-up" data-aos-delay="450">
                <a 
                  onClick={()=>appContext.navTo({item:'pprojects'})} 
                  className="btn btn-primary px-5 py-3 text-uppercase fw-semibold"
                  style={{ 
                    borderRadius: "8px", 
                    letterSpacing: "1px",
                    fontSize: "0.9rem",
                    boxShadow: "0 4px 14px rgba(59, 130, 246, 0.35)",
                    transition: "all 0.3s ease",
                    border: "none",
                    background: "linear-gradient(135deg, #3b82f6, #2563eb)"
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.transform = "translateY(-2px)";
                    e.target.style.boxShadow = "0 8px 25px rgba(59, 130, 246, 0.5)";
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.transform = "translateY(0)";
                    e.target.style.boxShadow = "0 4px 14px rgba(59, 130, 246, 0.35)";
                  }}
                >
                  Explore All Case Studies <span className="ms-2">→</span>
                </a>
              </div>
            }

          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading" style={{ paddingTop: "60px", paddingBottom: "60px" }}>
        {getInlineLoader()}
      </div>
    );
  }
}